// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import React, { useEffect } from 'react'
import { addListener } from '@reduxjs/toolkit'
import { useDispatch } from 'react-redux'
import moment from 'moment/moment'
import { CANCEL_VISIT_SUCCESS, GET_APPOINTMENT_SUCCESS } from '../../store/calendar/CalendarConstants'
import { getCurrentSchedule, getPatient } from '../../store/calendar/CalendarThunk'
import { setIsAppointmentPopUpInfoVisible } from '../../store/calendar/CalendarActions'
import { getMember } from '../../store/member/MemberThunk'
import { DEFAULT_DATE_VALUE_FORMAT_WITH_TZ } from '../../utils/dateUtils'

// @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
export const CalendarPageListener = ({ providerId, onCancelVisitSuccess, fromQuery }) => {
  const dispatch = useDispatch()
  const fromQueryFormat = moment(fromQuery).format(DEFAULT_DATE_VALUE_FORMAT_WITH_TZ)
  useEffect(() => {
    const unsubscribe = dispatch(
      addListener({
        predicate: () => true,
        effect: async (action, listenerApi) => {
          switch (action?.type) {
            case GET_APPOINTMENT_SUCCESS:
              // @ts-expect-error TS2769 -- MIGRATION: not approved, fix when encountered
              listenerApi.dispatch(getPatient(action?.payload?.PatientId, action?.extraData))
              // @ts-expect-error TS2769 -- MIGRATION: not approved, fix when encountered
              listenerApi.dispatch(getMember(action?.payload?.DoctorId, 'Provider', action?.extraData))
              break
            case CANCEL_VISIT_SUCCESS:
              // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
              if (providerId === action.extraData.providerId) {
                onCancelVisitSuccess()
                listenerApi.dispatch(
                  // @ts-expect-error TS2769 -- MIGRATION: not approved, fix when encountered
                  getCurrentSchedule(
                    // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
                    action.extraData.endpoints.fromValue ?? fromQueryFormat,
                    // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
                    action.extraData.endpoints.to,
                    providerId,
                  ),
                )
                // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
                listenerApi.dispatch(setIsAppointmentPopUpInfoVisible(false, action.extraData.visitId))
              }
              break
            default:
          }
        },
      }),
    )
    // @ts-expect-error TS2349 -- MIGRATION: not approved, fix when encountered
    return () => unsubscribe()
  }, [])

  return <div />
}
